import { memo, ReactElement } from "react";

import ManagePositionCta from "./ManagePositionCta";
import { RaydiumContextType } from "../raydium/types";

type ManagePositionWrapperProps = {
    children: ReactElement;
    context: RaydiumContextType;
    actionType: ActionType;
};

export type ActionType = "deposit" | "withdraw" | "open";

const ManagePositionWrapper = memo(function ManagePositionWrapper({
    children,
    context,
    actionType
}: ManagePositionWrapperProps) {
    const { isActionTypeInitialized } = context;

    const showCta = !isActionTypeInitialized || !isActionTypeInitialized.includes(actionType);

    if (showCta) return <ManagePositionCta context={context} actionType={actionType} />;

    return children;
});

export default ManagePositionWrapper;
